import { Routes } from '@angular/router';
import { BlankComponent, FullComponent } from './shell';
import { HomeComponent } from './pages/home/home.component';
import { AuthGuard } from './shell/services/guards/login.guard';
import { CallbackComponent } from './pages/authentication/callback/callback.component';
export const routes: Routes = [
  {
    path: '',
    component: FullComponent,
    children: [
      /* MODULOS-FINANCIALS: Seccion que conforma los modulos financieros */
      {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full',
      },
      {
        path: 'home',
        canActivate: [AuthGuard],
        component: HomeComponent,
      },
      {
        path: 'tesoreria',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./pages/tesoreria/tesoreria.module').then(
            (m) => m.TesoreriaModule,
          ),
      },
      {
        path: 'ingresos-administrativos',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./pages/ingresos-administrativos/ingresos-administrativos-routing.module').then(
            (m) => m.IngresosAdministrativosRoutingModule,
          ),
      },
      {
        path: 'pagos-administrativos',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./pages/pagos-administrativos/pagos-administrativos-routing.module').then(
            (m) => m.pagosAdministrativosRoutes,
          ),
      },
      {
        path: 'gestion-proveedores',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./pages/gestion-proveedores/gestion-proveedores-routing.module').then(
            (m) => m.GestionProveedoresRoutingModule,
          ),
      },
      {
        path: 'invoice',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./pages/invoice/invoice-routing.module').then(
            (m) => m.InvoiceRoutingModule,
          ),
      },
      {
        path: 'clientes',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./pages/clientes/clientes-routing.module').then(
            (m) => m.ClientesRoutingModule,
          ),
      },
      {
        path: 'proveedores-sourcing',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./pages/proveedores-sourcing/proveedores-sourcing.routes').then(
            (m) => m.proveedoresSourcingRoutes,
          ),
      },
      {
        path: 'transacciones',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./pages/transacciones/transacciones-routing.module').then(
            (m) => m.TransaccionesRoutingModule,
          ),
      },
      /* TEMPLATES: Seccion que conforma las rutas de template */
      {
        path: 'templates',
        loadChildren: () =>
          import('./pages/templates/templates.module').then(
            (m) => m.TemplatesModule,
          ),
      },

      /* Migrado a templates.routes.ts (dashboards)*/
      // {
      //   path: 'dashboards',
      //   loadChildren: () =>
      //     import('./pages/dashboards/dashboards.routes').then(
      //       (m) => m.DashboardsRoutes,
      //     ),
      // },

      /* Migrado a templates.routes.ts (ui-components)*/
      // {
      //   path: 'ui-components',
      //   loadChildren: () =>
      //     import('./pages/ui-components/ui-components.routes').then(
      //       (m) => m.UiComponentsRoutes,
      //     ),
      // },

      /* Migrado a templates.routes.ts (widgets)*/
      // {
      //   path: 'widgets',
      //   loadChildren: () =>
      //     import('./pages/widgets/widgets.routes').then((m) => m.WidgetsRoutes),
      // },

      /* Migrado a templates.routes.ts (forms)*/
      // {
      //   path: 'forms',
      //   loadChildren: () =>
      //     import('./pages/forms/forms.routes').then((m) => m.FormsRoutes),
      // },

      /* Migrado a templates.routes.ts (charts)*/
      // {
      //   path: 'charts',
      //   loadChildren: () =>
      //     import('./pages/templates/charts/charts.routes').then((m) => m.ChartsRoutes),
      // },

      /* Migrado a templates.routes.ts (apps)*/
      // {
      //   path: 'apps',
      //   loadChildren: () =>
      //     import('./pages/templates/apps/apps.routes').then((m) => m.AppsRoutes),
      // },

      /* Migrado a templates.routes.ts (tables)*/
      // { 
      //   path: 'tables',
      //   loadChildren: () =>
      //     import('./pages/tables/tables.routes').then((m) => m.TablesRoutes),
      // },

      /* Migrado a templates.routes.ts (datatable)*/
      // { 
      //   path: 'datatable',
      //   loadChildren: () =>
      //     import('./pages/templates/datatable/datatable.routes').then(
      //       (m) => m.DatatablesRoutes,
      //     ),
      // },

      /* Migrado a templates.routes.ts (theme-pages)*/
      // {
      //   path: 'theme-pages',
      //   loadChildren: () =>
      //     import('./pages/templates/theme-pages/theme-pages.routes').then(
      //       (m) => m.ThemePagesRoutes,
      //     ),
      // },
    ],
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'callback',
        component: CallbackComponent,
      },
      /* Migrado a templates.routes.ts (authentication)*/
      // {
      //   path: 'authentication',
      //   loadChildren: () =>
      //     import('./pages/templates/authentication/authentication.routes').then(
      //       (m) => m.AuthenticationRoutes,
      //     ),
      // },
      /* Migrado a templates.routes.ts (landingpage)*/
      // {
      //   path: 'landingpage',
      //   loadChildren: () =>
      //     import('./pages/templates/theme-pages/landingpage/landingpage.routes').then(
      //       (m) => m.LandingPageRoutes,
      //     ),
      // },

      /**/
      // {
      //   path: 'auth',
      //   loadChildren: () =>
      //     import('./auth/auth-routing.module').then((m) => m.AuthRoutingModule),
      // }, 
    ],
  },
  {
    path: '**',
    redirectTo: 'authentication/error',
  },
];
